var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","color":"transparent"}},[_c('v-card-title',{staticClass:"d-flex pa-0 justify-center text-center"},[_c('h1',{staticClass:"event-info primary--text"},[_vm._v(_vm._s(_vm.$t("event.title")))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }